(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[924],{

/***/ 63308:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fashion/women-accessories/[id]",
      function () {
        return __webpack_require__(60953);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 60953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ WomenCategoryMain; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(52875);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69779);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_components_BookAppliance_BookApplianceModal_BookApplianceShopByCategory_CategorySmallBanner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23433);
/* harmony import */ var src_store_slices_manageApplianceCategorySlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18829);
/* harmony import */ var src_store_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74573);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var src_components_Category_MainCategory_WomenCategory_WomanPageModal_WomenCategorySelectSection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94231);
/* harmony import */ var src_components_Category_ShopByCategoryDetails__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74759);
/* harmony import */ var src_components_Category_CategoryComman_SubCategoryProductSection__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81630);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9473);
/* harmony import */ var src_store_slices_fetchCategory__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4629);
/* harmony import */ var src_store_slices_fetchAllProduct__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87789);
/* harmony import */ var src_components_Shop_ShopCubeSlider__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(83803);
/* harmony import */ var src_store_slices_manageModalSlice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89013);
/* harmony import */ var src_components_Category_MainCategory_WomenCategory_WomanPageModal_WomenCategorySelectSection_WomenCategorySlider__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(89010);
/* harmony import */ var src_components_Category_MainCategory_WomenCategory_WomanPageModal_CategoryDetail__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(67679);
/* harmony import */ var src_components_Category_MainCategory_WomenCategory_WomanPageModal_BrowseCatagory__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(61625);
/* harmony import */ var src_components_Category_MainCategory_WomenCategory_WomanPageModal_Jeweleryarrival__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(11659);
/* harmony import */ var src_utils_isEmpty__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(96166);






















var Bagimage = "/assets/accessories/bagimage.png";
var Hatimage = "/assets/accessories/hatimage.png";
var Galssesimage = "/assets/accessories/galssesimage.png";
var Scarves = "/assets/accessories/scarves.png";
var __N_SSP = true;
function WomenCategoryMain(param) {
    var caterogoyName = param.caterogoyName;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), scrolling = ref1[0], setScrolling = ref1[1];
    var sub_category_slug = router === null || router === void 0 ? void 0 : router.pathname.split("/")[2];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), page = ref2[0], setPage = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(40), dataLimite = ref3[0], setDataLimite = ref3[1];
    var ref4 // Set initial max value
     = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1000), maxPrice = ref4[0], setMaxPrice = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1), minPrice = ref5[0], setMinPrice = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        total: 0,
        data: []
    }), productData = ref6[0], setProductData = ref6[1];
    var dispatch = (0,src_store_store__WEBPACK_IMPORTED_MODULE_4__/* .useAppDispatch */ .T)();
    var categoryData = (0,react_redux__WEBPACK_IMPORTED_MODULE_9__/* .useSelector */ .v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.fetchCategory) === null || ref === void 0 ? void 0 : ref.womenAccessoriesCategoryData;
    });
    var getAllState = (0,react_redux__WEBPACK_IMPORTED_MODULE_9__/* .useSelector */ .v9)(function(state) {
        var ref;
        return state === null || state === void 0 ? void 0 : (ref = state.manageModalData) === null || ref === void 0 ? void 0 : ref.data;
    });
    var filterData = categoryData === null || categoryData === void 0 ? void 0 : categoryData.find(function(cat) {
        var ref;
        return (cat === null || cat === void 0 ? void 0 : cat.slug) === (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.id);
    });
    var productByCategory = (0,react_redux__WEBPACK_IMPORTED_MODULE_9__/* .useSelector */ .v9)(function(state) {
        return state === null || state === void 0 ? void 0 : state.productByCategory;
    });
    var childCategoryValue = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.id;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setPage(1);
        dispatch((0,src_store_slices_fetchCategory__WEBPACK_IMPORTED_MODULE_10__/* .fetchCategoryBySlug */ .E)({
            type: "CHILD_SUB_CATEGORY",
            categoryName: "Fashion & Accessories",
            subcategoryName: sub_category_slug,
            childsubSlug: "",
            nestedSlug: ""
        }));
    }, []);
    var handleClose = function() {
        router.push("/fashion/women/", undefined, {
            scroll: false
        });
        dispatch((0,src_store_slices_manageApplianceCategorySlice__WEBPACK_IMPORTED_MODULE_3__/* .fetchApplianceCategory */ .O)({
            modal: "",
            isOpen: false,
            id: 0
        }));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleScroll = function() {
            setScrolling(window.scrollY);
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    var callAsPerRoute = function() {
        switch(caterogoyName){
            case "accessories":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
            case "public_collection":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
            default:
                return "";
        }
    };
    var handleOpenModal = function(param) {
        var modalName = param.modalName, title = param.title, description = param.description, color = param.color, childSubCategoryId = param.childSubCategoryId;
        dispatch((0,src_store_slices_manageModalSlice__WEBPACK_IMPORTED_MODULE_13__/* .fetchModalData */ .w)({
            allModalData: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(getAllState === null || getAllState === void 0 ? void 0 : getAllState.allModalData).concat([
                {
                    modal: modalName,
                    isOpen: true,
                    id: {
                        title: title,
                        description: description,
                        color: color,
                        childSubCategoryId: childSubCategoryId
                    },
                    modalFor: "bigModal"
                }, 
            ]),
            lastModalData: getAllState === null || getAllState === void 0 ? void 0 : getAllState.lastModalData
        }));
    };
    var womenImageArray = [
        {
            image: Bagimage,
            title: "Bags"
        },
        {
            image: Hatimage,
            title: "Hats"
        },
        {
            image: Galssesimage,
            title: "Glasses"
        },
        {
            image: Scarves,
            title: "Scarves"
        },
        {
            image: Bagimage,
            title: "Bags"
        },
        {
            image: Hatimage,
            title: "Hats"
        },
        {
            image: Galssesimage,
            title: "Glasses"
        },
        {
            image: Scarves,
            title: "Scarves"
        }, 
    ];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        dispatch((0,src_store_slices_fetchAllProduct__WEBPACK_IMPORTED_MODULE_11__/* .setProductByCategoryState */ .wW)({
            getAllProducts: {
                data: []
            }
        }));
        fetchProduct();
    }, [
        childCategoryValue,
        page,
        minPrice,
        maxPrice
    ]);
    var fetchProduct = function() {
        var maxPriceValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, minPriceValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        if ((0,src_utils_isEmpty__WEBPACK_IMPORTED_MODULE_19__/* .isZoreOrEmpty */ .K)(maxPriceValue) && (0,src_utils_isEmpty__WEBPACK_IMPORTED_MODULE_19__/* .isZoreOrEmpty */ .K)(minPriceValue) || maxPrice && minPrice) {
            var ref;
            dispatch((0,src_store_slices_fetchAllProduct__WEBPACK_IMPORTED_MODULE_11__/* .fetchProductByCategory */ .h4)({
                category: "fashion-and-accessories",
                subCategory: (router === null || router === void 0 ? void 0 : (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.includes("women-accessories")) ? "women-accessories" : "men-accessories",
                childSubCategory: childCategoryValue ? childCategoryValue : "",
                isShopifyProduct: false,
                page: page,
                limit: dataLimite,
                maxPrice: maxPriceValue || maxPrice,
                minPrice: minPriceValue || minPrice
            }));
        // .then((data) => {
        //   console.log('data+++++++++++++++++++++++++++++', data)
        //   setProductData(data?.payload?.getAllProducts)
        // })
        // .catch((error) => {
        //   console.log('error', error)
        // })
        }
    };
    var fetchUpdatedProduct = function(product_id, type) {
        var update_product = [];
        if (type === "price") {
            setMaxPrice(product_id === null || product_id === void 0 ? void 0 : product_id.maxValue);
            setMinPrice(product_id === null || product_id === void 0 ? void 0 : product_id.minValue);
            fetchProduct(product_id === null || product_id === void 0 ? void 0 : product_id.maxValue, product_id === null || product_id === void 0 ? void 0 : product_id.minValue);
        } else if (type === "dislike") {
            var ref;
            update_product = productData === null || productData === void 0 ? void 0 : (ref = productData.data) === null || ref === void 0 ? void 0 : ref.map(function(prd) {
                if ((prd === null || prd === void 0 ? void 0 : prd.id) === product_id) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, prd), {
                        likes: null
                    });
                } else {
                    return prd;
                }
            });
        } else if (type === "like") {
            var ref1;
            update_product = productData === null || productData === void 0 ? void 0 : (ref1 = productData.data) === null || ref1 === void 0 ? void 0 : ref1.map(function(prd) {
                if ((prd === null || prd === void 0 ? void 0 : prd.id) === product_id) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, prd), {
                        likes: {
                            id: 3.3333
                        }
                    });
                } else {
                    return prd;
                }
            });
        }
        dispatch((0,src_store_slices_fetchAllProduct__WEBPACK_IMPORTED_MODULE_11__/* .setProductByCategoryState */ .wW)({
            getAllProducts: {
                data: update_product
            }
        }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_BookAppliance_BookApplianceModal_BookApplianceShopByCategory_CategorySmallBanner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                categoryData: categoryData,
                scrollY: scrolling,
                handleClose: handleClose,
                pathname: "/fashion/".concat(sub_category_slug)
            }),
            caterogoyName === "accessories" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "Women-accecccies-page-layout-alignment",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            className: "Backbuttonmain",
                            onClick: function() {
                                return router.back();
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    d: "M16 19L9 12L16 5",
                                    stroke: "#7A7E88",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mobileSubCategory-back-alignment",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "back_details-alignment",
                                    onClick: function() {
                                        return router.push("/fashion/women");
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/assets/icon/left-icon.svg",
                                                alt: "back-page"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Woma..."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mobile-heading-alignment",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                        children: "Shop by Cate..."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "Women-accecccies-page-layout",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "womencatagoryslideralignment",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Category_MainCategory_WomenCategory_WomanPageModal_WomenCategorySelectSection_WomenCategorySlider__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                        colletionData: categoryData,
                                        subCategoryRoute: "women-accessories"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Category_MainCategory_WomenCategory_WomanPageModal_CategoryDetail__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    filterData: filterData,
                                    caterogoyName: caterogoyName,
                                    fontColor: "#000000"
                                }),
                                childCategoryValue && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Category_MainCategory_WomenCategory_WomanPageModal_BrowseCatagory__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    sub_category_slug: sub_category_slug,
                                    childsubSlug: childCategoryValue,
                                    backgroundColor: "#EEF1FD",
                                    imageBackgroundColor: "#D2D8F4",
                                    imageArray: womenImageArray,
                                    subcategoryName: "women-accessories",
                                    fontColor: "#00000"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Shop_ShopCubeSlider__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    handleOpenModal: handleOpenModal,
                                    modalName: "shopCubProductSeeAll",
                                    title: "From Brands You Love",
                                    description: "Highly rated products from brands you might like",
                                    height: "353px",
                                    color: "#F3E0D5",
                                    isSeeAll: true,
                                    childSubCategoryId: [
                                        [
                                            124
                                        ],
                                        [
                                            98
                                        ],
                                        [
                                            102
                                        ],
                                        [
                                            110
                                        ]
                                    ],
                                    titleColor: "#1E2432",
                                    descriptionColor: "#808191"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Category_MainCategory_WomenCategory_WomanPageModal_Jeweleryarrival__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    category: "jewelry",
                                    subCategory: "women",
                                    childSubCategory: ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Category_ShopByCategoryDetails__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    category_id: [
                                        35
                                    ],
                                    subCategory_id: [
                                        18
                                    ],
                                    storetitle: "Accessories Stores",
                                    storeModalName: "jewelryStoreModal",
                                    clubTitle: "Accessories Clubs",
                                    dataLimite: dataLimite,
                                    setPage: setPage,
                                    page: page
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: childCategoryValue && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Category_MainCategory_WomenCategory_WomanPageModal_WomenCategorySelectSection__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            colletionData: categoryData,
                            fetchUpdatedProduct: fetchUpdatedProduct,
                            setPage: setPage,
                            page: page,
                            dataLimite: dataLimite,
                            subCategoryRoute: "women-accessories",
                            category: "Fashion & Accessories",
                            subCategory: "Women's Accessories",
                            childSubCategory: childCategoryValue
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-5",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Category_CategoryComman_SubCategoryProductSection__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                category: "Fashion & Accessories",
                                subCategory: "Women's Accessories",
                                childSubCategory: childCategoryValue,
                                page: page,
                                setPage: setPage,
                                fetchUpdatedProduct: fetchUpdatedProduct,
                                productData: productByCategory
                            })
                        })
                    ]
                })
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1403,3393,4231,9774,2888,179], function() { return __webpack_exec__(63308); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);